import { render, staticRenderFns } from "./Evolucion.vue?vue&type=template&id=2c494930"
import script from "./Evolucion.vue?vue&type=script&lang=js"
export * from "./Evolucion.vue?vue&type=script&lang=js"
import style0 from "./Evolucion.vue?vue&type=style&index=0&id=2c494930&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports